import * as React from "react";
import { memo } from "react";
import styled, { ThemeContext } from "styled-components";
import { themeGet } from "@styled-system/theme-get";
import { Text } from "pcln-design-system";
const IconWrapper = /*#__PURE__*/styled(Text).withConfig({
  displayName: "FlightsFill__IconWrapper",
  componentId: "sc-126fwh8-0"
})(["display:inline-block;"]);
function BaseComponent({
  title,
  titleId,
  ...props
}) {
  const themeContext = React.useContext(ThemeContext);
  const themeProps = {
    theme: themeContext
  };
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    focusable: false,
    "aria-hidden": true,
    role: "img",
    "aria-labelledby": titleId,
    ...props
  }, title ? React.createElement("title", {
    id: titleId
  }, title) : null, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: themeGet("palette.primary.base")(themeProps),
    d: "M22.18.75q.3.01.585.104l.185.072.127.127c.108.243.168.505.175.76l-.01.424c-.073 1.309-.77 2.505-2.065 3.914l-.344.364-.66.668-2.191 2.146.48 1.588a1.59 1.59 0 0 1 1.643.082l.127.092 1.397 1.397a1.5 1.5 0 0 1 .386 1.123c-.027.36-.184.696-.411.925l-.102.092-1.47 1.468 1.296 4.276c.1.332.032.69-.177.961l-.085.098-.547.547a.87.87 0 0 1-1.4-.204l-4.8-8.822-1.094 1.092-1.035 1.023a20.4 20.4 0 0 1-2.987 2.583l.346 4.464a.34.34 0 0 1-.09.24l-.54.54a.37.37 0 0 1-.59-.09l-1.814-3.607-.026.012a1.4 1.4 0 0 1-1.372-.084l-.129-.09a1.41 1.41 0 0 1-.273-1.325l.085-.226-3.601-1.81a.37.37 0 0 1-.178-.204l-.017-.068a.37.37 0 0 1 .06-.264l.045-.054.54-.54a.34.34 0 0 1 .174-.085l.066-.005 4.465.354a20.3 20.3 0 0 1 2.191-2.586l.406-.393 2.12-2.134-8.835-4.808a.87.87 0 0 1-.291-1.314l.08-.089.549-.548a1.07 1.07 0 0 1 1.057-.261L7.906 3.97 9.34 2.54a1.5 1.5 0 0 1 2.068-.252l.124.103 1.422 1.426c.395.51.43 1.189.134 1.723l1.598.485 2.135-2.196.478-.478q.243-.238.472-.453l.447-.405C19.525 1.345 20.552.812 21.776.759z"
  }), React.createElement("path", {
    fill: themeGet("palette.primary.light")(themeProps),
    d: "M18.86 11.85a.57.57 0 0 1 .628-.065l.084.054 1.333 1.339.042.056a.51.51 0 0 1-.054.595l-.059.057-1.13 1.125-.93-3.07.015-.022zm-8.392-8.865a.5.5 0 0 1 .31.08l.064.049 1.363 1.364.042.07a.58.58 0 0 1-.093.595l-.07.071-.02.016-3.073-.93 1.091-1.092.074-.078a.5.5 0 0 1 .312-.145"
  }), React.createElement("path", {
    fill: themeGet("palette.background.lightest")(themeProps),
    d: "m21.692 2.329.032.041.09.1a1.195 1.195 0 0 1-.092 1.6.275.275 0 1 1-.386-.392.645.645 0 0 0 0-.918l-.034-.044-.078-.065a.655.655 0 0 0-.842.068.275.275 0 1 1-.387-.39 1.205 1.205 0 0 1 1.697 0"
  })));
}
const FlightsFill = props => React.createElement(IconWrapper, {
  fontSize: props.size,
  lineHeight: props.size,
  verticalAlign: "middle",
  className: props.className
}, React.createElement(BaseComponent, null));
/** @public */
const Memo = memo(FlightsFill);
export default Memo;